import { SAVE_BRANCH_ACTION,GET_ALL_BRANCHES_SUCCESS_ACTION} from "./Constants";

const INTIAL_STATE = {
  branchId: 1,
  branches:[],
  numberOfPages:0
};

export default function dashboardReducer(state = INTIAL_STATE, action) {
  switch (action.type) {
    case GET_ALL_BRANCHES_SUCCESS_ACTION:
      return{
        ...state,
        branches:action.data.branches,
        numberOfPages:action.data.numberOfPages
      }
    case SAVE_BRANCH_ACTION:
      return {
        ...state,
        branchId: action.branchId
      };
    default:
      return state;
  }
}
